import { Helmet } from "react-helmet-async";

export const OG_IMAGE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_dog-trainer-yeg/artifacts/b8scvr7l_image.png";

export const SEO = ({ title, description, path = "/" }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:type" content="website" />
    <meta property="og:image" content={OG_IMAGE} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:image" content={OG_IMAGE} />
    <link rel="canonical" href={`https://chinookk9.com${path}`} />
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        name: "Chinook K9",
        description: "Certified professional dog training serving Calgary, AB and surrounding areas.",
        telephone: "403-715-0499",
        email: "training@chinookk9.com",
        address: {
          "@type": "PostalAddress",
          streetAddress: "263001 Lochend Road",
          addressLocality: "Rocky View County",
          addressRegion: "AB",
          addressCountry: "CA",
        },
        openingHours: "Mo-Su 07:00-20:00",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          reviewCount: "120",
        },
        sameAs: [
          "https://www.instagram.com/chinookk9/",
          "https://www.facebook.com/chinookK9/",
        ],
      })}
    </script>
  </Helmet>
);
